import Employees from "@/views/rrhh/views/employees/store/employees.store.js";

export default {
    RRHHEmployeesStore: Employees,
};